import "./styles.scss";
import React from "react";
import { Link } from "gatsby";
import clsx from "clsx";

const Pill = ({ label, href, variant, selected }) => {
  return (
    <Link
      className={clsx(
        "pill",
        !!variant && `pill--${variant}`,
        !!selected && `pill--${variant}--selected`
      )}
      to={href}
    >
      {label}
    </Link>
  );
};

export default Pill;
